import additionalStates, { additionalStatesNames } from '@constants/values/additionalStates'

const stanPojazdu = { t: 'Stan pojazdu', inputs: [
    { t: 'Uszkodzony', type: 'all-checkbox', name: 'uszkodzone', options: ['Tak', 'Nie'], names: ['uszkodzone', 'nie-uszkodzone']},
    { t: 'Bezwypadkowy', type: 'all-checkbox', name: 'bezwypadkowe', options: ['Tak', 'Nie'], names: ['bezwypadkowe', 'po-wypadkowe']},
    { type: 'multi-checkbox', name: 'stan-dodatkowy', options: additionalStates, names: additionalStatesNames }
]}

export default stanPojazdu